<ion-content>
    <ion-fab horizontal="end" vertical="top" slot="fixed">
        <ion-fab-button color="danger" (click)="close()">
            <ion-icon name="close"></ion-icon>
        </ion-fab-button>
    </ion-fab>
    <div class="galleryItem" *ngFor="let item of (items||[])">
        <app-cached-image class="ds" [src]="appConfigService.getPictureUrlFromStorageFile(item.storageFile)"></app-cached-image>
    </div>
</ion-content>